import { lazy, Suspense, useEffect, useState } from 'react';

// The dialog (its search and result list) loads on the first Ctrl+K, so the admin shell stays small.
const CommandPaletteDialog = lazy(() =>
  import('./CommandPaletteDialog.jsx').then((m) => ({ default: m.CommandPaletteDialog })),
);

export const openCommandPalette = () => window.dispatchEvent(new Event('octbill:palette'));

/**
 * Ctrl+K (or ⌘K) anywhere in the admin area, or `openCommandPalette()`: jump to an admin page, a
 * client, invoice, order, service, domain, ticket or product. Once opened, the dialog stays mounted
 * (closed), so what was typed is still there next time. `sections`: the sidebar's permitted sections.
 */
export function CommandPalette({ sections }) {
  const [open, setOpen] = useState(false);
  const [used, setUsed] = useState(false);
  if (open && !used) setUsed(true);

  useEffect(() => {
    const onKey = (e) => {
      if ((e.ctrlKey || e.metaKey) && !e.altKey && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setOpen((o) => !o);
      }
    };
    const onOpen = () => setOpen(true);
    window.addEventListener('keydown', onKey);
    window.addEventListener('octbill:palette', onOpen);
    return () => {
      window.removeEventListener('keydown', onKey);
      window.removeEventListener('octbill:palette', onOpen);
    };
  }, []);

  if (!used) return null;
  return (
    <Suspense fallback={null}>
      <CommandPaletteDialog open={open} setOpen={setOpen} sections={sections} />
    </Suspense>
  );
}
